import { features } from "../app/permissions";

export const getFeatureMeta = (
  name: string
): { unit: string; display_name: string } | null => {
  const feature = features.find((f) => f.name === name);
  return feature
    ? { unit: feature.unit, display_name: feature.display_name }
    : null;
};
